import { render, staticRenderFns } from "./formAddAppointment.vue?vue&type=template&id=79922d94&scoped=true&"
import script from "./formAddAppointment.vue?vue&type=script&lang=js&"
export * from "./formAddAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79922d94",
  null
  
)

export default component.exports